import { fg } from '@atlassian/jira-feature-gating';

const VIEW_ISSUE_ALIAS = 'bentoViewIssue';

const getUserQueryFragment = () => `
    user {
        key
        accountId
        emailAddress
        avatarUrl
        displayName
        active
    }
`;

const getConfluencePagesQueryFragment = () => `
    pages {
        ... on ConfluencePage {
            id
            globalId
            href
            title
            type
            lastUpdatedContext {
                ${getUserQueryFragment()}
            }
        }
        ... on FailedRemoteLink {
            id
            error
            link {
                id
                globalId
                href
            }
            repairLink { href }
        }
    }
`;

const getConfluencePageGroupQueryFragment = () => `
    pageCount
    ${getConfluencePagesQueryFragment()}
`;

const getRemoteLinkedIssuesPreviewFragment = () => `
    id
    issueId
    globalId
    href
    applicationType
    applicationName
    relationship
    title
`;

const getAssociatedIssueFragment = () => `
    issueId
    issueKey {
        stringValue
    }
    summary {
        textValue
    }
    status {
        statusCategoryId
        name
        statusId
    }
    priority {
        iconUrl
        name
    }
    issueType {
        iconUrl
        name
    }
    assignee {
        userValue
        {
            displayName
            avatarUrl
        }
    }
   isResolved
`;

const getRemoteLinkedIssuesDetailsFragment = () => `
    ... on AssociatedIssueWrapper {
        associatedIssue {
            ${getAssociatedIssueFragment()}
        }
    }
    ... on FailedRemoteIssue {
        error
        repairLink { href }
    }
`;

const getRemoteLinkedIssuesFragment = () => `
    remoteLinkedIssues {
        preview {
            ${getRemoteLinkedIssuesPreviewFragment()}
        }
        details {
            ${getRemoteLinkedIssuesDetailsFragment()}
        }
    }
`;

export const getWebLinksFragment = () => `
    webLinks(allowThirdParties: true, orderBy: "-id") {
        linkCount
        links {
            id
            href
            linkText
            iconUrl
            summary
            resolved
            relationship
            applicationName
            applicationType
        }
    }
`;

const getRemoteDataQueryFragmentOld = () => `
    issueId
    remoteLinks {
       isLinkingEnabled
       confluencePages {
            linkedPages {
                ${getConfluencePageGroupQueryFragment()}
            }
            mentionedPages {
                ${getConfluencePageGroupQueryFragment()}
            }
        }
        ${getWebLinksFragment()}
        ${fg('jiv-21221_iv_remote_links_new_field') ? '' : getRemoteLinkedIssuesFragment()}
    }
`;

const getRemoteDataQueryFragmentNew = () => `
	issueId
	remoteLinks {
		isLinkingEnabled
		${getWebLinksFragment()}
        ${fg('jiv-21221_iv_remote_links_new_field') ? '' : getRemoteLinkedIssuesFragment()}
    }
`;

const getRemoteDataQueryFragment = () =>
	fg('jiv_confluence_remote_link_critical_query')
		? getRemoteDataQueryFragmentNew()
		: getRemoteDataQueryFragmentOld();

const getRemoteIssueLinksFragment = () => `
	remoteIssueLinks {
		edges {
			node {
				id
				globalId
				title
				relationship
				href
				content {
					__typename
					... on RemoteJiraIssueLinkResultSuccess {
						issueId
						key
						summary
						statusId
						statusName
						statusCategoryId
						isResolved
						issueTypeName
						issueTypeIconUrl
						priorityName
						priorityIconUrl
						assigneeDisplayName
						assigneeAvatarUrl
					}
					... on RemoteJiraIssueLinkResultError {
						errorType
						repairLink
					}
				}
			}
		}
	}
`;

export const getRemoteDataQueryPrefix = () => '_remote_data';

export const ISSUE_VIEW_REMOTE_DATA_QUERY = 'issueViewRemoteDataQuery';

export const getIssueRemoteDataQuery = () => `
    query ${ISSUE_VIEW_REMOTE_DATA_QUERY}($issueKey: String!) {
        ${VIEW_ISSUE_ALIAS}${getRemoteDataQueryPrefix()}: viewIssue(issueKey: $issueKey) {
        	${fg('jiv-21221_iv_remote_links_new_field') ? getRemoteIssueLinksFragment() : ''}
            ${getRemoteDataQueryFragment()}
        }
    }
`;
